"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _defaults = _interopRequireDefault(require("./defaults"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// a layer of aliases/variables that use default theme values
_defaults.default.breakpoints = R.pipe(R.values, R.sort(R.subtract))(_defaults.default.sizes);
_defaults.default.space = _defaults.default.spacing;
_defaults.default.alert = {
  background: {
    error: _defaults.default.colors.error[3],
    warning: _defaults.default.colors.warning[3],
    success: _defaults.default.colors.success[3],
    info: _defaults.default.colors.info[3]
  },
  icon: {
    error: _defaults.default.colors.error[1],
    warning: _defaults.default.colors.warning[1],
    success: _defaults.default.colors.success[1],
    info: _defaults.default.colors.info[1]
  }
};
_defaults.default.input = {
  fontColor: _defaults.default.colors.neutral[1],
  fontSize: "".concat(_defaults.default.fonts.size[2], "px"),
  shadow: _defaults.default.container.shadow[0],
  border: _defaults.default.colors.neutral[4],
  lineHeight: "".concat(_defaults.default.fonts.lineHeight[6], "px"),
  height: "".concat(_defaults.default.spacing[5], "px"),
  padding: '6px 10px',
  radius: "".concat(_defaults.default.container.radius[1], "px"),
  placeholderFontColor: _defaults.default.colors.neutral[3],
  transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
  clearIndicator: {
    hover: _defaults.default.colors.neutral[2]
  },
  error: {
    fontColor: _defaults.default.colors.error[0],
    fontSize: "".concat(_defaults.default.fonts.size[1], "px"),
    background: _defaults.default.colors.error[3],
    border: _defaults.default.colors.error[0],
    placeholderFontColor: _defaults.default.colors.neutral[2]
  },
  disabled: {
    background: _defaults.default.colors.neutral[5],
    multiBackground: _defaults.default.colors.neutral[3],
    placeholderFontColor: _defaults.default.colors.neutral[3],
    color: _defaults.default.colors.neutral[3]
  },
  focus: {
    border: _defaults.default.colors.primary[0]
  },
  label: {
    fontSize: "".concat(_defaults.default.fonts.size[2], "px"),
    fontColor: _defaults.default.colors.neutral[0]
  }
};
_defaults.default.typeahead = {
  group: {
    leftIndent: "".concat(_defaults.default.spacing[2], "px")
  },
  groupHeading: {
    fontSize: "".concat(_defaults.default.fonts.size[1], "px"),
    color: _defaults.default.colors.neutral[2],
    leftIndent: "-".concat(_defaults.default.spacing[2], "px")
  },
  multiValueLabel: {
    fontSize: "".concat(_defaults.default.fonts.size[1], "px"),
    lineHeight: "".concat(_defaults.default.fonts.lineHeight[4], "px")
  }
};
_defaults.default.container.border = ["1px solid ".concat(_defaults.default.colors.neutral[5])];
_defaults.default.textarea = {
  medium: {
    height: '72px'
  },
  large: {
    height: '152px'
  }
};
var _default = _defaults.default;
exports.default = _default;